var _a;
export var ESupportStaffRole;
(function (ESupportStaffRole) {
    ESupportStaffRole["SPORTS_DIRECTOR"] = "SPORTS_DIRECTOR";
    ESupportStaffRole["SPORTS_DIRECTOR_ASSISTANT"] = "SPORTS_DIRECTOR_ASSISTANT";
    ESupportStaffRole["COACH"] = "COACH";
    ESupportStaffRole["HEAD_COACH"] = "HEAD_COACH";
    ESupportStaffRole["ASSISTANT_COACH"] = "ASSISTANT_COACH";
    ESupportStaffRole["TECHNICAL_COACH"] = "TECHNICAL_COACH";
    ESupportStaffRole["COORDINATOR"] = "COORDINATOR";
    ESupportStaffRole["CONDITIONING_COACH"] = "CONDITIONING_COACH";
    ESupportStaffRole["ANALYST"] = "ANALYST";
    ESupportStaffRole["VIDEO_ANALYST"] = "VIDEO_ANALYST";
    ESupportStaffRole["GOALKEEPER_COACH"] = "GOALKEEPER_COACH";
    ESupportStaffRole["PHYSIOTHERAPIST"] = "PHYSIOTHERAPIST";
    ESupportStaffRole["HEAD_OF_LOGISTICS"] = "HEAD_OF_LOGISTICS";
    ESupportStaffRole["EQUIPMENT_MANAGER"] = "EQUIPMENT_MANAGER";
    ESupportStaffRole["LAUNDRY_MANAGER"] = "LAUNDRY_MANAGER";
    ESupportStaffRole["DOCTOR"] = "DOCTOR";
})(ESupportStaffRole || (ESupportStaffRole = {}));
export var supportStaffRoleTranslations = (_a = {},
    _a[ESupportStaffRole.SPORTS_DIRECTOR] = {
        sl: "Športni direktor",
        en: "Sports Director"
    },
    _a[ESupportStaffRole.SPORTS_DIRECTOR_ASSISTANT] = {
        sl: "Pomočnik športnega direktorja",
        en: "Assistant Sports Director"
    },
    _a[ESupportStaffRole.COACH] = {
        sl: "Trener",
        en: "Coach"
    },
    _a[ESupportStaffRole.HEAD_COACH] = {
        sl: "Glavni trener",
        en: "Head Coach"
    },
    _a[ESupportStaffRole.ASSISTANT_COACH] = {
        sl: "Pomočnik trenerja",
        en: "Assistant Coach"
    },
    _a[ESupportStaffRole.TECHNICAL_COACH] = {
        sl: "Tehnični vodja",
        en: "Technical Coach"
    },
    _a[ESupportStaffRole.COORDINATOR] = {
        sl: "Koordinator",
        en: "Coordinator"
    },
    _a[ESupportStaffRole.CONDITIONING_COACH] = {
        sl: "Kondicijski trener",
        en: "Conditioning Coach"
    },
    _a[ESupportStaffRole.ANALYST] = {
        sl: "Analitik",
        en: "Analyst"
    },
    _a[ESupportStaffRole.VIDEO_ANALYST] = {
        sl: "Video analitik",
        en: "Video Analyst"
    },
    _a[ESupportStaffRole.GOALKEEPER_COACH] = {
        sl: "Trener vratarjev",
        en: "Goalkeeper Coach"
    },
    _a[ESupportStaffRole.PHYSIOTHERAPIST] = {
        sl: "Fizioterapevt",
        en: "Physiotherapist"
    },
    _a[ESupportStaffRole.HEAD_OF_LOGISTICS] = {
        sl: "Vodja logistike",
        en: "Head of Logistics"
    },
    _a[ESupportStaffRole.EQUIPMENT_MANAGER] = {
        sl: "Ekonom",
        en: "Equipment Manager"
    },
    _a[ESupportStaffRole.LAUNDRY_MANAGER] = {
        sl: "Ekonom",
        en: "Laundry Manager"
    },
    _a[ESupportStaffRole.DOCTOR] = {
        sl: "Zdravnik",
        en: "Doctor"
    },
    _a);
export function ESupportStaffRoleToPretty(value, language) {
    if (language === void 0) { language = 'sl'; }
    return supportStaffRoleTranslations[value][language] || supportStaffRoleTranslations[value].sl;
}
